import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Column, Row, SizedBox } from "../CommonBaseComponents";
import { createPortal } from "react-dom";
import { StyledRadio } from "../radio/CustomRadios";
import { useClickOutside } from "../../hooks/useClickOutside";
import { FixedPositionDropdownWrapper } from "./CustomDropdownWrapper";
import { Theme } from "../../Theme";

const DROPDOWN_WIDTH = 196;

// 숨겨진 실제 라디오 버튼
const HiddenInput = styled.input.attrs({ type: "radio" })`
    display: none; /* 화면에서 완전히 숨김 */
`;

const QRPrintSettingDropdownMenu = ({ initValue, setValue, onClose, anchorEl, placement = "bottom-end" }) => {
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const menuRef = useRef(null);

    useClickOutside(menuRef, (event) => {
        // anchorEl(버튼) 클릭 시에는 toggleMenu가 처리하도록 무시
        if (anchorEl && anchorEl.contains(event.target)) {
            return;
        }
        if (onClose) onClose();
    });

    useEffect(() => {
        if (anchorEl) {
            const rect = anchorEl.getBoundingClientRect();
            let leftPos;

            if (placement === "bottom-end") {
                leftPos = rect.right - DROPDOWN_WIDTH;
            } else {
                // 'bottom-start'
                leftPos = rect.left;
            }

            setPosition({
                top: rect.bottom + window.scrollY + 8, // 버튼 바로 아래 + 8px 여백
                left: leftPos + window.scrollX,
            });
        }
    }, [anchorEl, placement]);

    // 라디오 버튼 변경 핸들러
    const handleChange = (value) => {
        console.log(`Selected value: ${value}`);
        setValue(Number(value));
        if (onClose) onClose();
    };

    const dropdownContent = (
        <FixedPositionDropdownWrapper $top={position.top} $left={position.left} ref={menuRef} $width={DROPDOWN_WIDTH}>
            <Row width={"100%"} justifyContent={"center"} alignItem={"flex-start"}>
                <Column cursor={"pointer"} onClick={() => handleChange(1)}>
                    <HiddenInput
                        name="printType" // name이 동일해야 그룹으로 묶입니다.
                        value={1}
                        checked={initValue === 1}
                        readOnly
                    />
                    <StyledRadio $checked={initValue === 1} />
                    <SizedBox height={"7px"} />
                    <SizedBox
                        width={"48px"}
                        height={"38px"}
                        borderRadius={"6px"}
                        backgroundColor={Theme.color.neutral100}
                        border={`1px solid ${Theme.color.gray200}`}
                    />
                </Column>
                <SizedBox width={"10px"} />
                <Column cursor={"pointer"} onClick={() => handleChange(2)}>
                    <HiddenInput
                        name="printType" // name이 동일해야 그룹으로 묶입니다.
                        value={2}
                        checked={initValue === 2}
                        readOnly
                    />
                    <StyledRadio $checked={initValue === 2} />
                    <SizedBox height={"7px"} />
                    <SizedBox
                        width={"48px"}
                        height={"38px"}
                        borderRadius={"6px"}
                        backgroundColor={Theme.color.neutral100}
                        border={`1px solid ${Theme.color.gray200}`}
                    />
                    <SizedBox height={"6px"} />
                    <SizedBox
                        width={"48px"}
                        height={"38px"}
                        borderRadius={"6px"}
                        backgroundColor={Theme.color.neutral100}
                        border={`1px solid ${Theme.color.gray200}`}
                    />
                </Column>
                <SizedBox width={"10px"} />
                <Column cursor={"pointer"} onClick={() => handleChange(3)}>
                    <HiddenInput
                        name="printType" // name이 동일해야 그룹으로 묶입니다.
                        value={3}
                        checked={initValue === 3}
                        readOnly
                    />
                    <StyledRadio $checked={initValue === 3} />
                    <SizedBox height={"7px"} />
                    <SizedBox
                        width={"48px"}
                        height={"38px"}
                        borderRadius={"6px"}
                        backgroundColor={Theme.color.neutral100}
                        border={`1px solid ${Theme.color.gray200}`}
                    />
                    <SizedBox height={"6px"} />
                    <SizedBox
                        width={"48px"}
                        height={"38px"}
                        borderRadius={"6px"}
                        backgroundColor={Theme.color.neutral100}
                        border={`1px solid ${Theme.color.gray200}`}
                    />
                    <SizedBox height={"6px"} />
                    <SizedBox
                        width={"48px"}
                        height={"38px"}
                        borderRadius={"6px"}
                        backgroundColor={Theme.color.neutral100}
                        border={`1px solid ${Theme.color.gray200}`}
                    />
                </Column>
            </Row>
        </FixedPositionDropdownWrapper>
    );

    return createPortal(dropdownContent, document.body);
};

export default QRPrintSettingDropdownMenu;
